import { defineNuxtPlugin } from '#app'
import type { Router } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
    const router = nuxtApp.$router as Router

    router.afterEach((to) => {
        if (to.hash) {
            const hash = decodeURIComponent(to.hash)
            let attempts = 0
            const maxAttempts = 100

            const scroll = () => {
                const anchorElement = document.querySelector(hash)

                if (anchorElement) {
                    anchorElement.scrollIntoView({ behavior: 'smooth' })
                } else if (attempts < maxAttempts) {
                    attempts++
                    requestAnimationFrame(scroll)
                }
            }

            setTimeout(scroll, 50)
        }
    })
})
